import { useState } from 'react'
import { Footer } from '../components/Footer'

export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsSubmitting(true)
    setSubmitStatus('idle')

    // TODO: Implémenter l'envoi du formulaire via l'API
    try {
      // Simuler l'envoi
      await new Promise((resolve) => setTimeout(resolve, 1000))
      setSubmitStatus('success')
      setFormData({ name: '', email: '', subject: '', message: '' })
    } catch (error) {
      setSubmitStatus('error')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="min-h-screen flex flex-col page-container">
      <div className="flex-1 max-w-2xl mx-auto px-4 py-8 w-full page-content">
      <h1 className="text-3xl font-bold mb-6 text-primary">Contactez-nous</h1>
      
      <div className="card">
        <p className="mb-6 text-secondary">
          Vous avez une question ou besoin d'assistance ? N'hésitez pas à nous contacter
          via le formulaire ci-dessous.
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="name" className="block text-sm font-medium mb-2 form-label">
              Nom complet
            </label>
            <input
              type="text"
              id="name"
              required
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className="form-input"
            />
          </div>

          <div>
            <label htmlFor="email" className="block text-sm font-medium mb-2 form-label">
              Email
            </label>
            <input
              type="email"
              id="email"
              required
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              className="form-input"
            />
          </div>

          <div>
            <label htmlFor="subject" className="block text-sm font-medium mb-2 form-label">
              Sujet
            </label>
            <input
              type="text"
              id="subject"
              required
              value={formData.subject}
              onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
              className="form-input"
            />
          </div>

          <div>
            <label htmlFor="message" className="block text-sm font-medium mb-2 form-label">
              Message
            </label>
            <textarea
              id="message"
              required
              rows={6}
              value={formData.message}
              onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              className="form-input"
            />
          </div>

          {submitStatus === 'success' && (
            <div className="px-4 py-3 rounded-md alert-success">
              Votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais.
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="px-4 py-3 rounded-md alert-error-solid">
              Une erreur est survenue lors de l'envoi. Veuillez réessayer plus tard.
            </div>
          )}

          <button
            type="submit"
            disabled={isSubmitting}
            className="button button--primary w-full disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? 'Envoi en cours...' : 'Envoyer le message'}
          </button>
        </form>

        <div className="mt-8 pt-6 border-top-light">
          <h3 className="text-lg font-semibold mb-4 text-primary">Autres moyens de contact</h3>
          <p className="text-secondary">
            Email :{' '}
            <a
              href="mailto:support@therapia.solutions"
              className="action-link"
            >
              support@therapia.solutions
            </a>
          </p>
        </div>
      </div>
      </div>
      <Footer />
    </div>
  )
}

